// TownEye trilingual strings — mirrors the mobile app copy.
// Keep keys short and hierarchical. Always include ar, he, en.

const S = {
  // Common
  back: { ar: "رجوع", he: "חזור", en: "Back" },
  save: { ar: "حفظ", he: "שמור", en: "Save" },
  cancel: { ar: "إلغاء", he: "ביטול", en: "Cancel" },
  loading: { ar: "جارٍ التحميل…", he: "טוען…", en: "Loading…" },
  edit: { ar: "تعديل", he: "ערוך", en: "Edit" },
  share: { ar: "مشاركة", he: "שתף", en: "Share" },
  comment: { ar: "تعليق", he: "תגובה", en: "Comment" },
  support: { ar: "ادعم", he: "תמיכה", en: "Support" },
  emergency: { ar: "طوارئ", he: "חירום", en: "Emergency" },
  citizen: { ar: "مواطن", he: "אזרח", en: "Citizen" },
  report: { ar: "بلاغ", he: "דיווח", en: "Report" },
  new_label: { ar: "جديد", he: "חדש", en: "New" },

  // Bottom nav
  tab_home: { ar: "الرئيسية", he: "ראשי", en: "Home" },
  tab_reports: { ar: "بلاغات", he: "דיווחים", en: "Reports" },
  tab_map: { ar: "الخريطة", he: "מפה", en: "Map" },
  tab_projects: { ar: "مشاريع", he: "פרויקטים", en: "Projects" },
  tab_account: { ar: "حساب", he: "חשבון", en: "Account" },

  // Home
  home_whats_happening: {
    ar: (city) => `ماذا يحدث في ${city}؟`,
    he: (city) => `מה קורה ב${city}?`,
    en: (city) => `What's happening in ${city}?`,
  },
  home_subtitle: {
    ar: "أبلِغ، تابع وحسِّن مجتمعك.",
    he: "דווח, עקוב ושפר את הקהילה שלך.",
    en: "Report, follow and improve your community.",
  },
  home_action_issue_title: { ar: "أبلغ عن مشكلة", he: "דווח על בעיה", en: "Report an issue" },
  home_action_issue_sub: { ar: "حفر، إضاءة، نفايات…", he: "בורות, תאורה, אשפה…", en: "Potholes, lighting, trash…" },
  home_action_emergency_title: { ar: "بلاغ طارئ", he: "דיווח חירום", en: "Emergency report" },
  home_action_emergency_sub: { ar: "حريق، فيضان، خطر سلامة", he: "שריפה, הצפה, סכנת בטיחות", en: "Fire, flood, safety hazard" },
  home_action_announcements_title: { ar: "إعلانات البلدية", he: "הודעות העירייה", en: "Municipality news" },
  home_action_announcements_sub: { ar: "تحديثات البلدية", he: "עדכוני העירייה", en: "City updates" },
  home_action_projects_title: { ar: "مشاريع المجتمع", he: "פרויקטים קהילתיים", en: "Community projects" },
  home_action_projects_sub: { ar: "ادعم المبادرات المحلية", he: "תמוך ביוזמות מקומיות", en: "Support local initiatives" },
  home_community_digest: { ar: "خلاصة المجتمع", he: "תקציר הקהילה", en: "Community digest" },
  home_press_to_view: { ar: "اضغط للعرض", he: "לחץ לצפייה", en: "Tap to view" },

  // Profile
  profile_add_bio: {
    ar: "أضف نبذة قصيرة ليتعرف عليك الجيران",
    he: "הוסף תיאור קצר כדי שהשכנים יכירו אותך",
    en: "Add a short bio so your neighbors get to know you",
  },
  profile_edit_button: { ar: "تعديل الملف الشخصي", he: "ערוך פרופיל", en: "Edit profile" },
  profile_stat_reports: { ar: "البلاغات", he: "דיווחים", en: "Reports" },
  profile_stat_resolved: { ar: "تم حلها", he: "נפתרו", en: "Resolved" },
  profile_stat_support: { ar: "الدعم", he: "תמיכה", en: "Support" },
  profile_action_new: { ar: "بلاغ جديد", he: "דיווח חדש", en: "New report" },
  profile_action_my: { ar: "بلاغاتي", he: "הדיווחים שלי", en: "My reports" },
  profile_action_messages: { ar: "الرسائل", he: "הודעות", en: "Messages" },
  profile_action_settings: { ar: "الإعدادات", he: "הגדרות", en: "Settings" },
  profile_latest_reports: { ar: "أحدث بلاغاتي", he: "הדיווחים האחרונים שלי", en: "My latest reports" },
  profile_empty_title: { ar: "لا توجد بلاغات بعد", he: "אין דיווחים עדיין", en: "No reports yet" },
  profile_empty_sub: {
    ar: "عندما تبلِّغ عن مشكلة في قريتك ستظهر هنا لتتمكّن من متابعتها.",
    he: "כשתדווח על בעיה ביישובך היא תופיע כאן כדי שתוכל לעקוב.",
    en: "When you report an issue in your locality, it will appear here so you can follow it.",
  },

  // Edit profile
  editp_title: { ar: "تعديل", he: "עריכה", en: "Edit" },
  editp_cover_hint: { ar: "اضغط لإضافة صورة الغلاف", he: "לחץ להוספת תמונת רקע", en: "Tap to add cover photo" },
  editp_display_name: { ar: "اسم العرض", he: "שם תצוגה", en: "Display name" },
  editp_locality: { ar: "YOUR LOCALITY", he: "היישוב שלך", en: "YOUR LOCALITY" },
  editp_village: { ar: "القرية", he: "כפר", en: "Village" },
  editp_phone: { ar: "الهاتف", he: "טלפון", en: "Phone" },
  editp_whatsapp: { ar: "WHATSAPP", he: "WHATSAPP", en: "WHATSAPP" },
  editp_bio: { ar: "نبذة قصيرة", he: "ביוגרפיה קצרה", en: "Short bio" },
  editp_saved: { ar: "تم حفظ التعديلات", he: "השינויים נשמרו", en: "Profile saved" },

  // Settings
  settings_title: { ar: "الإعدادات", he: "הגדרות", en: "Settings" },
  settings_locality: { ar: "YOUR LOCALITY", he: "היישוב שלך", en: "YOUR LOCALITY" },
  settings_preferences: { ar: "PREFERENCES", he: "העדפות", en: "PREFERENCES" },
  settings_account: { ar: "ACCOUNT", he: "חשבון", en: "ACCOUNT" },
  settings_language: { ar: "اللغة", he: "שפה", en: "Language" },
  settings_notifications: { ar: "الإشعارات", he: "התראות", en: "Notifications" },
  settings_edit_profile: { ar: "تعديل", he: "ערוך פרופיל", en: "Edit profile" },
  settings_privacy: { ar: "الخصوصية والأمان", he: "פרטיות ואבטחה", en: "Privacy & Security" },
  settings_help: { ar: "المساعدة والدعم", he: "עזרה ותמיכה", en: "Help & Support" },
  settings_logout: { ar: "تسجيل الخروج", he: "התנתק", en: "Log out" },

  // Reports list
  reports_title: { ar: "بلاغات المجتمع", he: "דיווחי הקהילה", en: "Community Reports" },
  reports_summary: {
    ar: (total, urgent) => `${urgent} طارئ · ${total} الإجمالي`,
    he: (total, urgent) => `${urgent} דחופים · ${total} סה"כ`,
    en: (total, urgent) => `${urgent} urgent · ${total} total`,
  },
  reports_filter_all: { ar: "الكل", he: "הכל", en: "All" },
  reports_new_button: { ar: "بلاغ", he: "דיווח", en: "Report" },

  // Map
  map_title: { ar: "خريطة المجتمع", he: "מפת הקהילה", en: "Community map" },
  map_pins: { ar: (n) => `${n} موقع`, he: (n) => `${n} סיכות`, en: (n) => `${n} pins` },

  // Projects (community)
  projects_title: { ar: "مشاريع المجتمع", he: "פרויקטים קהילתיים", en: "Community projects" },
  projects_share: { ar: "ماذا تريد أن تشارك؟", he: "מה תרצה לשתף?", en: "What would you like to share?" },
  projects_publish: { ar: "نشر", he: "פרסם", en: "Post" },
  projects_empty: { ar: "لا توجد مشاركات بعد. ابدأ المحادثة!", he: "אין פוסטים עדיין. התחל את השיחה!", en: "No posts yet. Start the conversation!" },

  // Messages
  messages_title: { ar: "الرسائل", he: "הודעות", en: "Messages" },
  messages_subtitle: {
    ar: "المحادثات الخاصة قريباً. حالياً، علِّق على البلاغات لبدء محادثة.",
    he: "צ׳אט פרטי בקרוב. לעת עתה, תגיב על דיווחים כדי להתחיל שיחה.",
    en: "Private chat is coming soon. For now, comment on reports to start a conversation.",
  },
};

/** Resolve a string. `t(strings, key, language, ...args)` */
export function t(key, language, ...args) {
  const entry = S[key];
  if (!entry) return key;
  const val = entry[language] || entry.en || entry.ar;
  return typeof val === "function" ? val(...args) : val;
}

export default S;
